import { Component, OnInit } from '@angular/core';

import { DatePipe } from '@angular/common';
import { MaeConstanciaResumenM } from 'src/app/model/mae-constancia-bean';
import { ReporteConstanciasM } from 'src/app/model/reporte-bean';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeConstanciaService } from 'src/app/service/mae-constancia.service';
import { ReporteService } from 'src/app/service/reporte.service';
import { ExcelService } from 'src/app/service/utilitarios/excel.service';

@Component({
  selector: 'app-reporte-total-alumnos',
  templateUrl: './reporte-total-alumnos.component.html',
  styleUrls: ['./reporte-total-alumnos.component.scss']
})
export class ReporteTotalAlumnosComponent implements OnInit {

  constructor(
    private utilitarioService:UtilitarioService,
    private maeConstanciaService:MaeConstanciaService,
    private excelService:ExcelService,
    private reporteService:ReporteService,){

  }

  headElements = ['Nro','Fecha','Curso','Formato','Nro. Alumnos'];

  listResultado = new Array<ReporteConstanciasM>();

  cboCurso:String='0';
  conrango:boolean=false;

  fecha_ini:String;
  fecha_fin:String;

  page = 1;
  pageSize = 10;

  ngOnInit(): void {

    var datePipe = new DatePipe("en-US");
    var hoy = new Date();
    this.fecha_ini = datePipe.transform(hoy, 'yyyy-MM-dd');
    this.fecha_fin = datePipe.transform(hoy, 'yyyy-MM-dd');

  }
  onBuscar()
  {
    var f_ini=this.fecha_ini.toString();
    var f_fin=this.fecha_fin.toString();

    this.utilitarioService.loading = true;
    this.reporteService.getTotalAlumnos(f_ini,f_fin).subscribe(data=>{
      this.listResultado = data;
      this.utilitarioService.loading = false;
    });
  }
  onExportarExcel(){
    this.excelService.exportExcelReporteTotalAlumnos(this.listResultado);
  }
}
